var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"text-h6 pa-5 pb-2"},[_vm._v(" "+_vm._s(_vm.modalFormComponent.title)+" ")]),_c('property-form',{attrs:{"value":_vm.formValue,"fields":_vm.fieldDefs},on:{"input":_vm.doSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }